import { render, staticRenderFns } from "./SFIcon.vue?vue&type=template&id=4c689390&lang=pug&"
import script from "./SFIcon.vue?vue&type=script&lang=ts&"
export * from "./SFIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports